import { Component, Input, OnChanges } from '@angular/core';

export interface StepsFlags {
  searchPatient?: boolean;
  selectDate?: boolean;
  payment?: boolean;
  showSummary?: boolean;

  prescriptionData?: boolean;
  prescriptionSummary?: boolean;

  examOrderData?: boolean;
  examOrderSignature?: boolean;
  examOrderSummary?: boolean;
}

@Component({
  selector: 'app-steps-doctor',
  templateUrl: './steps-doctor.component.html',
  styleUrls: ['./steps-doctor.component.css']
})
export class StepsDoctorComponent implements OnChanges {

  @Input() steps!: StepsFlags;
  @Input() showSuccessMessage?: boolean;

  @Input() uiStepsInput: any[] | null = null;
  @Input() currentStepInput: number | null = null;

  @Input() theme: 'doctor' | 'documents' | 'exam-order' = 'doctor';

  currentStep = 0;

  uiStepsDefault = [
    { title: 'Datos del paciente', icon: 'fi fi-rr-search' },
    { title: 'Fecha y hora', icon: 'fi fi-rr-calendar' },
    { title: 'Motivo y tarifa', icon: 'fi fi-rr-credit-card' },
    { title: 'Confirmación', icon: 'fi fi-rr-envelope' }
  ];

  uiSteps = this.uiStepsDefault;

  ngOnChanges(): void {
    this.uiSteps = this.uiStepsInput && this.uiStepsInput.length
      ? this.uiStepsInput
      : this.uiStepsDefault;

    this.currentStep = this.currentStepInput !== null && this.currentStepInput !== undefined
      ? this.currentStepInput
      : this.computeCurrentStep();
  }

  private computeCurrentStep(): number {
    if (this.showSuccessMessage) {
      return this.uiSteps.length - 1;
    }

    if (!this.steps) {
      return 0;
    }

    /**
     * Receta electrónica
     */
    if (this.steps.prescriptionSummary) return 2;
    if (this.steps.prescriptionData) return 1;

    /**
     * Orden de examen
     */
    if (this.steps.examOrderSummary) return 3;
    if (this.steps.examOrderSignature) return 2;
    if (this.steps.examOrderData) return 1;

    /**
     * Reserva médica normal
     */
    if (this.steps.showSummary) return 3;
    if (this.steps.payment) return 2;
    if (this.steps.selectDate) return 1;

    return 0;
  }

  progressPercent(): number {
    return ((this.currentStep + 1) / this.uiSteps.length) * 100;
  }

}